import { isValidStorefrontCode } from 'types/models/storefront'
import { parseQuery, parseURL, withoutLeadingSlash, withoutTrailingSlash, withQuery } from 'ufo'

/**
 * return the url without the storefront code (e.g. /uk/) and without a forward slash
 */
export function stripStorefrontCodeFromUrl(slug: string) {
  const url = parseURL(slug)
  const pathname = url.pathname
  const config = useRuntimeConfig()
  const env = config.public?.environment ?? 'production'
  const slugWithoutForwardSlash = withoutLeadingSlash(pathname)

  const potentialStorefrontCode = withoutTrailingSlash(slugWithoutForwardSlash.split('/')[0])

  const storefrontCode = isValidStorefrontCode(potentialStorefrontCode, env)
  ? potentialStorefrontCode
  : null

  const restOfUrl
    = (storefrontCode && slugWithoutForwardSlash.substring(storefrontCode.length)) || ''

  const query = parseQuery(url.search)

  const urlWithoutStorefrontCode = withQuery(storefrontCode ? restOfUrl : pathname, query)

  return {
    storefrontCode,
    urlWithoutStorefrontCode,
    urlWithoutStorefrontCodeWithoutForwardSlash: urlWithoutStorefrontCode.startsWith('/')
      ? urlWithoutStorefrontCode.slice(1)
      : urlWithoutStorefrontCode,
  }
}
